import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import { SIZE } from 'baseui/input'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'

const NumberOfOccupants = () => {
  const { t, energyLandscape, updateAddressEnergyLandscape, errors } = useAddress()
  return (
    <SDFormControl plainLabel error={getError('occupantsNumber', errors)}>
      <SDInput
        label={t('subscriptionTools:estimator.occupants_number.label')}
        size={SIZE.compact}
        currentValue={energyLandscape?.numberOfOccupants}
        pattern={'[0-9]+'}
        min={'1'}
        max={'7'}
        onBlur={numberOfOccupants => updateAddressEnergyLandscape({ numberOfOccupants })}
      />
    </SDFormControl>
  )
}

export default NumberOfOccupants
